import mixpanel from 'mixpanel-browser';
import { useCallback } from 'react';
import { trackingEnvEnabled } from './useAnalytics';
import { useUser } from './useUser';

type EventProperties = Record<string, any>;

export const useTracking = () => {
  const { data: user } = useUser();

  const trackEvent = useCallback(
    (eventName: string, properties?: EventProperties) => {
      if (trackingEnvEnabled && user) {
        mixpanel.track(eventName, properties);
      }
    },
    []
  );

  const timeEvent = useCallback((eventName: string) => {
    if (trackingEnvEnabled && user) {
      mixpanel?.time_event(eventName);
    }
  }, []);

  return { trackEvent, timeEvent };
};
